import { supabase } from '@/lib/supabase'
import { fetchAllPaged } from '@/lib/fetchAllPaged'

// U17 S3: the run page's QC defect tally read qc_responses in one request, so
// PostgREST's 1,000-row cap silently dropped the rest of a big run's answers.
// Read in pages (ordered on the key so pages do not overlap) and throw on a
// failed page: a short tally would read as a confident, smaller count.
export async function fetchRunDefectTally(qcRunIds: string[]): Promise<{ code: string; count: number }[]> {
  if (qcRunIds.length === 0) return []
  const { rows, error } = await fetchAllPaged<{ answer_options: string[] | null }>((from, to) =>
    supabase.from('qc_responses')
      .select('answer_options')
      .in('qc_run_id', qcRunIds)
      .not('answer_options', 'is', null)
      .order('response_id')
      .range(from, to) as unknown as PromiseLike<{ data: { answer_options: string[] | null }[] | null; error: { message: string } | null }>,
    { maxRows: 100_000 })
  if (error) throw new Error(error)
  const tally = new Map<string, number>()
  for (const r of rows) for (const code of r.answer_options ?? []) tally.set(code, (tally.get(code) ?? 0) + 1)
  return Array.from(tally.entries()).map(([code, count]) => ({ code, count })).sort((a, b) => b.count - a.count)
}
